/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FreelancerVertical = {
    Regular: 'REGULAR',
    Strategy: 'STRATEGY'
} as const;
export type FreelancerVertical = typeof FreelancerVertical[keyof typeof FreelancerVertical];


export function instanceOfFreelancerVertical(value: any): boolean {
    for (const key in FreelancerVertical) {
        if (Object.prototype.hasOwnProperty.call(FreelancerVertical, key)) {
            // @ts-ignore
            if (FreelancerVertical[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreelancerVerticalFromJSON(json: any): FreelancerVertical {
    return FreelancerVerticalFromJSONTyped(json, false);
}

export function FreelancerVerticalFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerVertical {
    return json as FreelancerVertical;
}

export function FreelancerVerticalToJSON(value?: FreelancerVertical | null): any {
    return value as any;
}

